import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4a87e6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workorder-info" }
const _hoisted_2 = { class: "info-title" }
const _hoisted_3 = { class: "info-value" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "info-title"
}
const _hoisted_7 = {
  key: 1,
  class: "info-title"
}
const _hoisted_8 = {
  key: 2,
  class: "info-value"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 3,
  class: "info-value"
}

import { onMounted, ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import { DateObject, Workorder } from "@/classes";
import NumberField from "../base/inputs/NumberField.vue";
import Decimal from "decimal.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkorderDialog',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

onMounted(() => console.log);

const emits = __emit;

const dialog = ref(false);
const workorder = ref<Workorder>(new Workorder());
const loading = ref(false);

const open = async (id: string | null) => {
  dialog.value = true;
  if (id) {
    workorder.value = await Workorder.get(id);
  } else {
    workorder.value = new Workorder();
  }
};

const fields: {
  title: string;
  key: keyof Workorder;
  format?: (val: any) => string;
}[] = [
  { title: "Order Type", key: "order_type" },
  { title: "Notification", key: "notification" },
  { title: "Order", key: "order" },
  {
    title: "Basic Start Date",
    key: "basic_start_date",
    format: (val: any) => (val instanceof DateObject ? val.toString() : val),
  },
  { title: "Statutory Flag", key: "statutory_flag_display" },
  { title: "Functional Location", key: "functional_location" },
  { title: "Description", key: "description" },
  { title: "System Status", key: "system_status" },
  { title: "User Status", key: "user_status" },
  { title: "Main Work Center", key: "main_work_center" },
  { title: "Planner Group", key: "planner_group" },
  { title: "Maintenance Plan", key: "maintenance_plan" },
  { title: "Maintenance Item", key: "maintenance_item" },
  {
    title: "Created On",
    key: "created_on",
    format: (val: any) => (val instanceof DateObject ? val.toString() : val),
  },
];

const save = async () => {
  loading.value = true;
  await workorder.value.save();
  loading.value = false;
  dialog.value = false;
  emits("change");
};

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
    maxWidth: "1000",
    title: "Workorder"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        loading: loading.value,
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("Save")
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.filter((_, i) => i % 2 === 0), (_, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(fields[i * 2].title), 1),
              _createElementVNode("td", _hoisted_3, [
                (fields[i * 2].format)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fields[i * 2].format(workorder.value[fields[i * 2].key])), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(workorder.value[fields[i * 2].key]), 1))
              ]),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(fields[i * 2 + 1].title), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_7)),
              (i * 2 + 1 < fields.length)
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                    (fields[i * 2 + 1].format)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(fields[i * 2 + 1].format(workorder.value[fields[i * 2 + 1].key])), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(workorder.value[fields[i * 2 + 1].key]), 1))
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_11))
            ]))
          }), 128))
        ])
      ]),
      _createVNode(NumberField, {
        class: "mt-4",
        "model-value": workorder.value.hour.toNumber(),
        "text-align": "left",
        label: "Hour",
        variant: "outlined",
        density: "compact",
        required: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (workorder.value.hour = new (_unref(Decimal))($event)))
      }, null, 8, ["model-value"]),
      _createVNode(NumberField, {
        "model-value": workorder.value.cost.toNumber(),
        "text-align": "left",
        label: "Cost",
        prefix: "$",
        variant: "outlined",
        density: "compact",
        required: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (workorder.value.cost = new (_unref(Decimal))($event)))
      }, null, 8, ["model-value"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})